import type { PopOverDirections } from '@lightspeed/design-system-react'
import { T } from '@transifex/react'
import React, { ReactNode } from 'react'
import { SsboSellStepBody } from './SsboSellStepBody'

const BODY_CONTEXT = 'SSBO guided tour step body'

export type SsboTourStepId =
  | 'sell'
  | 'pay'
  | 'lspayTerminal'
  | 'lspayCnp'
  | 'complete'

export type SsboTourStepConfig = {
  id: SsboTourStepId
  /** Which side of the anchor the pop-up sits. */
  placement: PopOverDirections
  /** Fallback placement when `placement` doesn't fit the viewport. */
  narrowPlacement?: PopOverDirections
  body: ReactNode
}

// Ordered by the sequence the merchant walks through.
export const SSBO_TOUR_STEPS: SsboTourStepConfig[] = [
  {
    id: 'sell',
    placement: 'topCenter',
    body: <SsboSellStepBody />,
  },
  {
    id: 'pay',
    placement: 'topCenter',
    narrowPlacement: 'center',
    body: (
      <T
        _str='Select "Lightspeed Payments" to continue checkout setup.'
        _context={BODY_CONTEXT}
      />
    ),
  },
  {
    id: 'lspayTerminal',
    placement: 'right',
    narrowPlacement: 'topCenter',
    body: (
      <T
        _str="No physical terminal yet? Tap 'Enter card details manually' to continue."
        _context={BODY_CONTEXT}
      />
    ),
  },
  {
    id: 'lspayCnp',
    placement: 'left',
    narrowPlacement: 'center',
    body: (
      <T
        _str="Enter card details to complete test transaction. This transaction activates payouts and completes account setup."
        _context={BODY_CONTEXT}
      />
    ),
  },
  {
    id: 'complete',
    placement: 'topCenter',
    body: (
      <T
        _str='Payment successful. Tap "Complete sale" to finish the order. Go to the dashboard to continue store setup.'
        _context={BODY_CONTEXT}
      />
    ),
  },
]

export const SSBO_TOUR_TOTAL_STEPS = SSBO_TOUR_STEPS.length

// 1-based step number for the counter ("N of 5")
export const getSsboTourStepNumber = (id: SsboTourStepId): number =>
  SSBO_TOUR_STEPS.findIndex(step => step.id === id) + 1

export const getSsboTourStep = (
  id: SsboTourStepId
): SsboTourStepConfig | undefined =>
  SSBO_TOUR_STEPS.find(step => step.id === id)
